import { CurrencyNumberPipe } from '../../../../infrastructure/shared/pipes/currency-number.pipe';
import { Component, computed, input, model, output } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Tooltip } from 'primeng/tooltip';
import { CompanyPackageDto } from '../../../../infrastructure/shared/model/fss.api';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../../../infrastructure/shared/ui/button/button';
import { Cube01 } from '../../../../infrastructure/shared/icons/cube-01/cube-01';
import { XClose } from '../../../../infrastructure/shared/icons/x-close/x-close';
import { InfoCircle } from '../../../../infrastructure/shared/icons/info-circle/info-circle';
import { CheckCircle } from '../../../../infrastructure/shared/icons/check-circle/check-circle';

@Component({
  standalone: true,
  selector: 'app-buy-package-dialog',
  imports: [
    Dialog,
    Tooltip,
    CurrencyNumberPipe,
    ButtonComponent,
    Cube01,
    XClose,
    InfoCircle,
    CheckCircle,
  ],
  templateUrl: './buy-package-dialog.html',
  styleUrl: './buy-package-dialog.scss',
})
export class BuyPackageDialog {
  isVisible = model.required<boolean>();
  pkg = input.required<CompanyPackageDto>();
  confirmed = output<void>();

  protected packageName = computed(() => {
    const h = this.pkg()?.hours ?? 0;
    if (h <= 6) return `Studio ${h}`;
    if (h <= 15) return `Pro ${h}`;
    return `Partner ${h}`;
  });

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  onConfirm(): void {
    this.confirmed.emit();
    this.isVisible.set(false);
  }

  onCancel(): void {
    this.isVisible.set(false);
  }
}
